import React from "react";
import { HomePageHeaderTemplate } from "themes/application/home/components";

function HomePageHeader(props) {
    return <HomePageHeaderTemplate {...props} />;
}

export default HomePageHeader;
